export class CircularQueue<T> {
  private items: T[];

  private currentIndex: number;

  constructor(items: T[]) {
    if (!items.length) {
      throw new Error('Items array cannot be empty');
    }
    this.items = items;
    this.currentIndex = 0;
  }

  public get(): T {
    const item = this.items[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    return item;
  }

  public getItems(): T[] {
    return [...this.items];
  }

  public setItems(items: T[]): void {
    if (!items.length) {
      throw new Error('Items array cannot be empty');
    }
    this.items = items;
    this.currentIndex = 0;
  }
}
